export const langs = {
    'zh': { lang: 'zh', full: 'zh-CN', gaName: 'language_chinese' },
    'ko': { lang: 'ko', full: 'ko-KR', gaName: 'language_korean'  },
    'ja': { lang: 'ja', full: 'ja-JP', gaName: 'language_japanese'  },
    'it': { lang: 'it', full: 'it-IT', gaName: 'language_italian'  },
    'en': { lang: 'en', full: 'en-US', gaName: 'language_english'  },
    'de': { lang: 'de', full: 'de-DE', gaName: 'language_deutsch'  },
    'fr': { lang: 'fr', full: 'fr-FR', gaName: 'language_french'  },
    'es': { lang: 'es', full: 'es-419', gaName: 'language_spanish'  },
    'nl': { lang: 'nl', full: 'nl-NL', gaName: 'language_dutch'  }
  }